module.exports = __webpack_public_path__ + "img/customers.b749248c.svg";